const clone_prod_dg_template = `
<div id="dialog-devicegroup-settings" class="modal-dialog modal-lg production-device-group-settings">
    <div class="modal-content">
        <div class="modal-header">
            <div class="modal-title">{{title}}{{#if name}}:{{/if}}
                <div class="secondary-text">{{name}}</div>
            </div>
            <button class="btn-close" data-dismiss="modal">X</button>
            <div class="modal-alert-container">
                <div class="alert"></div>
            </div>
        </div>
        <form>
            <div class="modal-body">
                <div class="form-group col-xs-6">
                    <label for="name">Device Group Name</label>
                    <input type="text" maxlength="100" name="name" placeholder="Enter a name..." class="form-control name" />
                    <span class="help-block name-counter">0 / 100</span>
                    <label for="description">Device Group Description</label>
                    <textarea class="form-control description" name="description" maxlength="300" placeholder="Enter description here"></textarea>
                    <span class="help-block description-counter">0 / 300</span>
                    <div class="account-region"></div>
                    <div class="product-region"></div>
                </div>
                <div class="form-group col-xs-6">
                    <div class="form-group">
                        <label class="region-label">Region <span class="glyphicon glyphicon-question-sign"
                            aria-hidden="true" data-toggle="tooltip" data-placement="bottom"
                            title="Select a Region for all of the devices in this group. Once set, it cannot be changed." />
                        </label>
                    </div>
                    <div class="form-group region-dropdown"></div>
                    {{#if devicegroup_profiles}}
                        <label for="profile">Profile <span class="glyphicon glyphicon-question-sign"
                            aria-hidden="true" data-toggle="tooltip" data-placement="bottom"
                            title="A device group's profile can be used to run it's devices on special development servers. 
                            Setting it to Default will make it's devices run on the usual software. 
                            Not all device group profiles may be available in all Regions." />
                        </label>
                        <select name="profile" class="form-control devicegroup-profile">
                            {{#each devicegroup_profiles}}
                            <option value="{{this.id}}" {{#if this.selected}}selected{{/if}}>{{this.attributes.name}}</option>
                            {{/each}}
                        </select>
                    {{/if}}
                    <div class="blessing-options">
                      <h4 class="subtitle">
                          {{production_device_group_settings_modal_subtitle}}
                      </h4>
                      <div class="radio">
                        <label class="blessing-description">
                          <input type="radio" name="blessing-options" value="blessing">
                              {{immediately_deploy_after_blessing}} <strong>({{recommended}})</strong>
                        </label>
                      </div>
                      <div class="radio">
                        <label class="blessing-description">
                          <input type="radio" name="blessing-options" value="blinkup">
                              {{deploy_after_blinkup}}
                        </label>
                      </div>
                    </div>
                    <div class="environment-variables">
                        <label for="env_vars">Environment Variables</label>
                        {{#if edit_env_vars}}
                            <textarea rows="6" class="form-control env_vars" name="env_vars"
                                placeholder="Write Environment Variables here as valid JSON">{{env_vars}}</textarea>
                            <span class="help-block">Custom variables that can be used in the Device Group's code. Only Owners have permissions to edit. 
                            Must be valid JSON.  Keys must be alphanumeric, and start with a letter. Values must be strings or numbers.  A new deployment
                            will need to be created, and devices restarted.</span>
                            <pre class="help-block code">e.g. {"foo":"bar"}</pre>
                        {{else}}
                            {{#if show_env_vars_keys}}
                                <pre class="code">{{env_vars_keys}}</pre>
                                <span class="help-block">Custom Variables to use in this Device Group's code. Only Owners have permissions to edit. 
                                Values may be strings, booleans, or numbers.</span>
                            {{/if}}
                        {{/if}}
                     </div>
                </div>
                <div class="form-group col-xs-12">
                    <div class="webhook-options">
                        <div class='subtitle'>
                            {{webhook}}
                            <span class='info' data-toggle="tooltip" data-delay="0">
                                <span class='glyphicon glyphicon-question-sign'></span>
                            </span>
                        </div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>{{event}}</th>
                                    <th>{{url}}</th>
                                    <th>{{content_type}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">{{blessing}}</th>
                                    <td><input class="form-control blessing" type="url" id="blessing-url"></td>
                                    <td>
                                        <select class="form-control blessing" id="blessing-type">
                                        <option value="application/json">application/json ({{recommended}})</option>
                                        <option value="application/x-www-form-urlencoded">application/x-www-form-urlencoded</option>
                                    </select>
                                    </td>
                                    <td class='action'></td>
                                </tr>
                                <tr>
                                    <th scope="row">{{blinkup}}</th>
                                    <td><input class="form-control blinkup" type="url" id="blinkup-url"></td>
                                    <td>
                                        <select class="form-control blinkup" id="blinkup-type">
                                        <option value="application/json">application/json ({{recommended}})</option>
                                        <option value="application/x-www-form-urlencoded">application/x-www-form-urlencoded</option>
                                    </select>
                                    </td>
                                    <td class='action'></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="form-group totp-form col-xs-12">
                    <label for="totp-input">This account requires MFA for Production Deployments, enter your code below.</label>
                    <input type="text" maxlength="6" name="totp-input" placeholder="Enter Code" class="form-control totp-input" />
                </div>
            </div>
            <div class="modal-footer clear">
                <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary submit" disabled>Clone</button>
            </div>
        </form>
    </div>
</div>

`;


/*
    Looks like this is also the settings dialog for Pre-Factory Workspaces (pre_factoryfixture_devicegroup)
*/


import Radio from 'backbone.radio';
import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import _ from 'underscore';
import DialogInterface from '@/interfaces/dialog';
import PaginatedMenuView from '@/views/paginated_menu_view';
import strings_specific from 'amdi18n-loader!@/nls/production_device_group_settings';
import strings_common from 'amdi18n-loader!@/nls/common';
import ProductSelector from '@/views/modules/product_selector';
import AccountSelector from '@/views/modules/account_selector';

let strings = _.extend({}, strings_common, strings_specific);
const MAX_DESCRIPTION_LENGTH = 300;
const MAX_NAME_LENGTH = 100;

const globalCh = Backbone.Radio.channel('global');
const apiCh = Backbone.Radio.channel('api');
    
function perm_check(active, primary, type){
    if ( type === 'production_devicegroup' && active.permits(primary, 'update_production_vars') ) {
        return true;
    } else if ( type === 'pre_production_devicegroup' && active.permits(primary, 'update_pre_production_vars') ){
        return true;
    }
    return false;
}

var post_webhook = function (devicegroup, webhook_url, event, content_type) {
    var apiCh = Radio.channel('api');
    var webhooks = apiCh.request('webhook');
    return new Promise(function (resolve, reject) {
        webhooks.create({
            type: 'webhook',
            attributes: {
                event: event,
                content_type: content_type,
                url: webhook_url,
            },
            relationships: {
                devicegroup: {
                    id: devicegroup.id,
                    type: devicegroup.type
                }
            }
        }, {
                wait: true,
                success: resolve,
                error: function(webhook, response){
                    reject(response);
                }
            });
    });
};

const view = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(clone_prod_dg_template),
    blessing_webhook: null,
    blinkup_webhook: null,
    changed: {
        load_code_after_blessing: false,
        blessing_url: false,
        blinkup_url: false
    },
    on_success: function () {
        this.closeDialog();
    },
    clone_model: undefined,
    initialize: function (options) {
        this.owner = this.model.rel.get('owner');
        this.product = this.model.rel.get('product');
        this.deployment = this.model.rel.get('current_deployment');
        if (this.deployment) this.deployment.fetch();
        this.destroyOnClose();
        this.focusFirstInput();
        _.bindAll(this, 'handle_success', 'handle_error');
    },
    ui: {
        blessing_options: 'input[name=blessing-options]',
        blessing_option: 'input[name=blessing-options]:checked',
        blessing_url: '#blessing-url',
        blinkup_url: '#blinkup-url',
        blessing_type: '#blessing-type',
        blinkup_type: '#blinkup-type',
        submit: '.btn.submit',
        tooltips: '[data-toggle="tooltip"]',
        blessing_content: '.blessing',
        blinkup_content: '.blinkup',
        inputs: 'input',
        name: '.form-control.name',
        description: '.form-control.description',
        name_length_counter: '.name-counter',
        description_length_counter: '.description-counter',
        region_dropdown: '.region-dropdown',
        region_label: '.region-label',
        totp_form: '.totp-form',
        totp_input: '.totp-input',
        env_vars: '.environment-variables',
        env_vars_textarea: '.environment-variables textarea',
        account_region: '.account-region',
        product_region: '.product-region'
    },
    regions: {
        region_menu: '@ui.region_dropdown',
        account_region: '@ui.account_region',
        product_region: '@ui.product_region',
    },
    templateContext: function () {
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');
        let dialog_title = this.model.type === 'pre_production_devicegroup' 
                ? 'Clone Test Production Device Group' 
                : 'Clone Production Device Group';
        let name = this.model.get('name');
        let type = this.model.type;
        let is_create = true;
        let env_vars = null;
        let env_vars_keys = null;
        let edit_env_vars = false;
        let show_env_vars_keys = false;
        
        if ( this.model && this.model.get('env_vars') ) { 
            env_vars = JSON.stringify(this.model.get('env_vars'), null, 4);
        }
        if ( perm_check(active, primary, type) ) {
            edit_env_vars = true;
        } else {
            show_env_vars_keys = true;
            if ( this.model && this.model.get('env_vars') ) {
                env_vars_keys = Object.keys(this.model.get('env_vars'));
            }
        }
        if ( !env_vars_keys ) env_vars_keys = "no variables";
        return _.extend({}, strings, {
            name: name,
            title: dialog_title,
            type: this.model.type_readable(),
            is_create: is_create,
            show_env_vars_keys: show_env_vars_keys,
            edit_env_vars: edit_env_vars,
            env_vars: env_vars,
            env_vars_keys: env_vars_keys
        });
    },
    onRender: function () {
        this.ui.tooltips.tooltip({
            placement: 'bottom',
            title: `<div>${strings.tooltip_1}</div>
                    <div><strong>${strings.blessing}</strong>${strings.tooltip_2}</div>
                    <div><strong>${strings.blinkup}</strong>${strings.tooltip_3}</div>`,
            html: true,
            template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
        });

        if ( !this.mfa_required() ) this.ui.totp_form.hide();

        if (_.has(this.model.attributes, 'load_code_after_blessing')) {
            if (this.model.attributes.load_code_after_blessing === true) {
                this.ui.blessing_options.filter(function () { return this.value == 'blessing'; }).prop('checked', true);
                this.blessing_option = 'blessing';
            } else {
                this.ui.blessing_options.filter(function () { return this.value == 'blinkup'; }).prop('checked', true);
                this.blessing_option = 'blinkup';
            }
        }
        this.ui.region_label.hide();
        this.ui.name.val( this.model.get('name') );
        this.ui.description.val( this.model.get('description') );
        this.validate();
        var webhooks = this.model.webhooks;
        webhooks.fetch().then(function () {
            webhooks.forEach(function (webhook) {
                var devicegroup = webhook.rel.get('devicegroup');
                if (devicegroup.id === this.model.id) {
                    if (webhook.get('event') === 'blessing') {
                        this.blessing_webhook = webhook;
                        this.ui.blessing_url.val(webhook.get('url'));
                        this.ui.blessing_type.val(webhook.get('content_type'));
                    } else if (webhook.get('event') === 'blinkup') {
                        this.blinkup_webhook = webhook;
                        this.ui.blinkup_url.val(webhook.get('url'));
                        this.ui.blinkup_type.val(webhook.get('content_type'));
                    }
                }
            }.bind(this));
        }.bind(this));
        this.maybeShowRegionsMenu();
        this.ui.blessing_options.filter(function () { return this.value == 'blessing'; }).prop('checked', true);
        this.blessing_option = 'blessing';
        this.showChildView('account_region', new AccountSelector({ model: this.model }));
        this.render_products(this.owner.id); 
    },
    render_products: function(val) {
        let products = apiCh.request('product');
        products.fetch({
            data: {
                'filter[owner.id]': val,
                'page[size]': 100
            },
        }).then((resp)=>{
            this.showChildView('product_region', new ProductSelector({ model: this.model, products: resp.data }));
        });
    },
    change_product: function(val) {
        this.product = apiCh.request('product', { id: val });
    },
    change_account: function(val) {
        this.render_products(val);
        this.owner = apiCh.request('account', { id: val });
        this.maybeShowRegionsMenu();
    },
    events: {
        'click @ui.submit': function (e) {
            this.submit(e);
        },
        'click @ui.blessing_option': function (e) {
            if (e.target.value === 'blessing') {
                this.blessing_option = 'blessing';
            } else {
                this.blessing_option = 'blinkup';
            }
        },
        'keyup': 'validate',
        'paste': 'validate',
        'change': 'validate',
        'mouseup': 'validate'
    },
    childViewEvents: {
        'change:account' : 'change_account',
        'change:product' : 'change_product'
    },
    validate: function() {
        if ( !this.validate_description()
                || !this.validate_name()
                || !this.validate_deployment()
                || !this.validate_totp()
        ){
            this.ui.submit.prop('disabled', true);
            return false;
        }

        this.ui.submit.prop('disabled', false);
        return true;
    },
    validate_deployment: function () {
        if ( this.deployment || this.model ) return true;
        return false;
    },
    validate_description: function () {
        this.check_validation(
            this.ui.description,
            MAX_DESCRIPTION_LENGTH,
            this.ui.description_length_counter
        );
        if ( this.ui.description.val() ) return true;
        // description is not required, but we still need to check the length
        return true;
    },
    validate_name: function () {
        this.check_validation(
            this.ui.name,
            MAX_NAME_LENGTH,
            this.ui.name_length_counter
        );
        if ( this.ui.name.val() ) return true;
        return false;
    },
    validate_totp: function () {
        if ( this.mfa_required() && this.ui.totp_input.val().length < 6 ) {
            return false;
        }
        return true;
    },
    submit: function (e) {
        if (e) {
            e.preventDefault();
            if (e.target.classList.contains('disabled')) {
                return;
            }

        }
        this.hideAlert();

        let load_code_after_blessing = this.blessing_option === 'blessing';
        let name = this.ui.name.val().trim();
        let description = this.ui.description.val().trim();

        let env_vars_string = this.ui.env_vars_textarea.val();
        let env_vars = null;
        try {
            env_vars = JSON.parse(env_vars_string);
        } catch ( e ) {
            if ( env_vars_string && env_vars_string.length > 0 ) {
                let error = {
                    responseJSON : {
                        errors: [
                            { detail: e }
                        ]
                    }
                };
                this.handle_error(error);
                return;
            }
        }

        this.create(name, description, load_code_after_blessing, env_vars);
    },

    create: function (name, description, load_code_after_blessing, env_vars) {
        var devicegroups = Radio.request('api', 'production_devicegroup');
        var cloud_regions = Radio.request('api', 'cloud_regions');
        var selected_region = null;
        var region_menu = this.getRegion('region_menu');
        let active = globalCh.request('active_account');
        let primary = globalCh.request('primary_account');


        if (cloud_regions && cloud_regions.length > 0) {
            selected_region = region_menu.currentView.selected_child;
        }
       
        var opts = {
            name: name,
            type: this.model.type,
            description: description,
        };

        if ( perm_check(active, primary, opts.type) ) {
            opts.env_vars = env_vars;
        }

        if (cloud_regions && cloud_regions.length > 0 && selected_region && selected_region.get('name') != 'Default' ) {
            opts.region = selected_region.get('name');
        } 
            
        return devicegroups.create(opts,
        {
            product: this.product,
            creator: primary.id,
            owner: this.owner.id,
            wait: true,
            success: function(model, response){
                this.clone_model = model;
                if ( this.deployment && this.deployment.get('sha') ) {
                    this.deploy_to_new_production_devicegroup();
                } else {
                    this.post_webhooks();
                }
            }.bind(this),
            error: function (model, err) {
                this.handle_error(err);
            }.bind(this),
        });
    },
    
    deploy_to_new_production_devicegroup: function() {
        var totp = this.ui.totp_input.val();
        var headers = {};
        let deployments = apiCh.request('deployment');
        if ( this.mfa_required() ) {
            headers = {
                'x-electricimp-otp-token': totp
            };
        }
        var options = {
            type: this.deployment.type,
            attributes: {
                description: this.deployment.get('description'),
                agent_code: this.deployment.get('agent_code'),
                device_code: this.deployment.get('device_code')
            },
            relationships: {
                devicegroup: this.clone_model.toReference(),
            }
        };
        deployments.create(
            options,
            {
            merge: true,
            // Without wait: true, ID is undefined 
            wait: true,
            headers: headers,
            success: function(model, response){
                this.post_webhooks();
            }.bind(this),
            error: function(model, err) {
                this.handle_error(err);
            }.bind(this),
        });
    },

    post_webhooks: function(){
        let blessing_url = this.ui.blessing_url.val().trim();
        let blinkup_url = this.ui.blinkup_url.val().trim();
        let blessing_type = this.ui.blessing_type.val();
        let blinkup_type = this.ui.blinkup_type.val();

        let calls = [];

        if ( blinkup_url ) {
            calls.push(post_webhook(this.clone_model, blinkup_url, 'blinkup', blinkup_type));
        }
        if ( blessing_url ) {
            calls.push(post_webhook(this.clone_model, blessing_url, 'blessing', blessing_type));
        }
        if ( calls.length == 0 ) {
            this.handle_success();
            return;
        }
        calls.forEach( call => { call.catch(error => { return error; }); } );

        Promise.all(calls).then(this.handle_success).catch(this.handle_error);
    },

    maybeShowRegionsMenu: function() {
        this.ui.region_label.hide();
        if (this.getOption('show_regions') === false) {
            return;
        }
        var cloud_regions = Radio.request('api', 'cloud_regions');
        var cloud_collection;
        var view_opts;
        var view;
        if ( cloud_regions && cloud_regions.length > 0) {
            this.ui.region_label.show();
            cloud_collection = new Backbone.Collection();
            // add assumed "default" region
            cloud_collection.add(new Backbone.Model({id: 'Default', name: 'Default'}));
            _.each(cloud_regions, function(r) { cloud_collection.add(new Backbone.Model({id: r, name: r})); });
            view_opts = {
                title: 'Choose a Region',
                collection: cloud_collection,
                childView: Marionette.View
            };
            view = new PaginatedMenuView(view_opts);
            this.showChildView('region_menu', view);
        }
    },
    // boolean variable if mfa is required for creating production deployments
    mfa_required: function() {
        if ( this.dialog_type === 'settings' ) return false;
        return this.options.product.rel.get('owner').get('deployment_mfa_required') && this.options.type === 'production_devicegroup';
    },
    handle_error: function (err) {
        if (err.responseJSON) {
            if (err.responseJSON.errors[0].code === 'VX015') {
                let detail = err.responseJSON.errors[0].detail;
                if (typeof detail === 'object' && detail.message) detail = detail.message; 
                detail = detail +  ' --- You have entered an invalid URL — please check your webhook settings. The expected format is "https://www.example.com"';
                err.responseJSON.errors[0].detail = detail;
            }
        }
        DialogInterface.showAlert.call(this, 'alert-danger', err);
    },
    handle_success: function (model, response, options) {
        this.closeDialog();
        Radio.request('alerts', 'showAlert', {
            message: `Cloned ${this.model.get('name')} to ${this.clone_model.get('name')}
                      in Product ${this.product.get('name')} owned by
                      Account ${this.owner.get('username')}.`,
            messageType: 'success'
        });
    }
});
export default view;

